import * as React from "react"
import { useEffect } from "react"
import { batch } from "@preact/signals-react"

import { Box } from "@mui/material"
import { CommonFilters } from "@components"
import {COMMON_FILTER_KEYS} from "@constants"
import { useAppDefaultFilters } from "@hooks"
import { isLoadingCommonFilters, isSystemBusy } from "@signals"
import { CUSTOM_DASHBOARD_ROUTES } from '@constants/routes'
import { amazonPPKpisIsEmpty } from "./@signals"


export default function AmazonPPKpisFilters() {

    const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(CUSTOM_DASHBOARD_ROUTES.AMAZON_PP_KPIS_ID, CUSTOM_DASHBOARD_ROUTES.ACCESS_KEY)

    useEffect(() => {
        callUserDefaultFilters()
    }, [])

    return <Box data-tour="amazon-pp-kpis-filters">
    <CommonFilters
        components={{
            country: true, site: true,
            category: true, brand: true,
            sku: true, favFilters: true,
            skuGroup: true, productsInStock: true
        }}
        compProps={{
            favFilters: {
                grid: { md: 3 },
                allowedFilters: [
                    COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
                    COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU
                ],
                dashboardKey: CUSTOM_DASHBOARD_ROUTES.AMAZON_PP_KPIS_ID
            },
            productsInStock: { grid: { md: 7 } },
            sku: { grid: { md: 6 } },
            country: { filters: { websiteType: "2" } },
            site: { filters: { websiteType: "2" } }
        }}
        onSubmit={() => { batch(() => {
            isLoadingCommonFilters.value = true
            amazonPPKpisIsEmpty.value = false
            isSystemBusy.value = false
        })}}
        defaultValues={userFilters}
        isLoadingDefaultFilters={isLoadingDefaultFilters}
    />
    </Box>
}
